/* eslint-disable no-nested-ternary */
import React from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import { OutlinedIcons, SolidIcons } from '@marageti/z4-lib';

const { OutlinedCheckCircleIcon } = OutlinedIcons;
const { SolidCheckCircleIcon, SolidXCircleIcon } = SolidIcons;

type StatusButtonProps = {
  isOpen: boolean;
  isCompleted: boolean;
  isCanceled: boolean;
  isTogglingComplete: boolean;
  onToggleComplete: () => void;
};

const StatusButton = ({
  isOpen,
  isCompleted,
  isCanceled,
  isTogglingComplete,
  onToggleComplete,
}: StatusButtonProps) => {
  const label = !isOpen ? 'Mark as Open' : 'Mark as Completed';

  if (isTogglingComplete) {
    return (
      <IconButton size="small" disabled>
        <CircularProgress size={24} />
      </IconButton>
    );
  }

  return (
    <Tooltip title={label}>
      <IconButton
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          e.preventDefault();
          onToggleComplete();
        }}
      >
        {isCanceled ? (
          <SolidXCircleIcon sx={{ color: 'grey.500' }} />
        ) : isCompleted ? (
          <SolidCheckCircleIcon
            sx={{ color: 'grey.500' }}
          />
        ) : (
          <OutlinedCheckCircleIcon
            color="primary"
          />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default StatusButton;
